import React from "react";
import AllPageFooter from "../../../PreviewPdf/AllPageFooter";

const IntroductionPage = React.memo(function IntroductionPage({
  pageNum,
  propLogo,
}) {
  return (
    <div className="page sheet">
      <section className="introFix">
        <div className="if-head">
          <div className="if-title">Introduction</div>
          <div className="if-rule" />
        </div>
        <div className="if-grid">
          <div>
            <p>
              Fire doors are an essential part of passive fire protection because
              they help prevent fire and smoke from spreading between rooms or
              compartments and into escape routes.
            </p>
            <p>
              By holding back the spread of fire and smoke into and along escape
              routes, occupants have more time to evacuate or reach a refuge, and
              crucially their escape route is much safer.
            </p>
            <p>
              A door&apos;s effectiveness relies on more than just the door leaf
              itself. There are many component parts working together to resist
              fire – the failure, poor specification, or incorrect installation
              of any one item could compromise the whole door assembly.
            </p>
            <div className="g-title">Legislation</div>
            <p>
              The main fire safety legislation for each UK country requires that
              the &apos;facilities, equipment and devices&apos; (i.e., fire doors
              and flat front doors) are &apos;subject to a suitable system of
              maintenance&apos; (i.e., ongoing inspection and repair).
            </p>
            <ul className="legis">
              <li>Regulatory Reform (Fire Safety) Order 2005</li>
              <li>Fire (Scotland) Act 2005</li>
              <li>The Fire Safety (Scotland) Regulations 2006</li>
              <li>Fire Safety Regulations (NI) 2010</li>
            </ul>
            <p>
              These fire safety laws are for England / Wales, Scotland, and
              Northern Ireland. They include inspecting and maintaining building
              safety and ongoing risk assessments.
            </p>
            <ul className="legis">
              <li>Fire Safety Act 2021</li>
            </ul>
            <p>
              This extends English fire safety law to include all buildings with
              two or more domestic premises. It explicitly brings into scope flat
              front doors.
            </p>
          </div>
          <div>
            <div className="g-title">Guidance</div>
            <div className="g-leadRow">
              <div className="g-vert" />
              <p className="g-lead">
                A variety of British and European standards apply to fire door
                assemblies, their component parts and the fire tests applied to
                them.
              </p>
            </div>
            <div className="g-box">
              <ul className="g-list">
                <li className="g-item">
                  <span className="std">BS EN 1634-1 : 2008</span>
                  <span className="desc">
                    Fire resistance and smoke control tests for doors, shutters
                    and openable windows.
                  </span>
                </li>
                <li className="g-item">
                  <span className="std">BS 476-22 : 1987</span>
                  <span className="desc">
                    Fire tests on building materials and structures.
                  </span>
                </li>
                <li className="g-item">
                  <span className="std">BS 8214 : 2016</span>
                  <span className="desc">Code of practice for fire door assemblies.</span>
                </li>
                <li className="g-item">
                  <span className="std">BS EN 1125 : 2008</span>
                  <span className="desc">Panic exit devices for use on escape routes.</span>
                </li>
                <li className="g-item">
                  <span className="std">BS EN 1935 : 2002</span>
                  <span className="desc">Building hardware – single-axis hinges.</span>
                </li>
                <li className="g-item">
                  <span className="std">BS EN 1155 : 1997</span>
                  <span className="desc">Building hardware – electro-magnetic devices.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <AllPageFooter pageNumber={pageNum} propLogo={propLogo} />
    </div>
  );
});

export default IntroductionPage;
